import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { Route } from '../Routes';
import { Box } from 'lucide-react';
import { PrimaryColor } from '../../styles/global/css/Utils';

const ProductsRoutes = (): Route[] => [
	{
		component: () => <></>,
		path: '/products',
		name: <Translate id="sidebar.catalog" />,
		logoImg: <Box size='16' />,
		hoverImg: <Box color={PrimaryColor} size='16' />,
		activeImg: <Box color={PrimaryColor} size='16' />,
		menu: true,
		subMenu: 'products',
		permission: ['ViewCatalog'],
		subroutes: [
			{ path: '/products-v2', name: <Translate id="products.beta" />, permission: ['ViewCatalog'] },
			{ path: '/assortments-v2', name: <Translate id="assortments.beta" />, permission: ['ViewCatalog'] },
			{ path: '/multi-dimension', name: <Translate id="assortments.multi_dimension" />, permission: ['ViewProductMultiDimension'], owner: true },
		]
	},
];

export default ProductsRoutes;
